module.exports = __webpack_public_path__ + "img/sort_up.553bccff.svg";